export const OG_IMAGE = {
	type: "image/jpeg",
	extension: ".jpg",
	width: 1200,
	height: 630,
} as const
